module.exports = __webpack_public_path__ + "static/media/Hind-Regular.dc2874ab.ttf";